import {
    getApplicableVariantMappingRepairs,
    getChannelValueReplacementPlan,
    selectChannelMappingReplacements,
    type ChannelMappingRepair
} from './variantMappingRepair';
import type { AttributeReplacement } from './variantMappingRepairStrategies/types';

/** Derive the complete dialog view from its original snapshot and the merchant's choices. */
export const buildChannelRepairPreview = (original: ChannelMappingRepair, replacements: readonly AttributeReplacement[] = []) => {
    const channel = selectChannelMappingReplacements(original, replacements);
    const repairable = getApplicableVariantMappingRepairs(channel.repairs);
    const repairableKeys = new Set(repairable.map((repair) => repair.key));
    return {
        channel,
        repairable,
        manualRepairs: channel.repairs.filter((repair) => !repairableKeys.has(repair.key)),
        strategyPreviews: channel.availableStrategies.filter((id) => repairable.some((repair) => repair.steps.some((step) => step.strategyID === id))),
        // Keep the original candidates so successfully resolved choices remain editable.
        replacementCandidates: getChannelValueReplacementPlan(original, replacements).candidates
    };
};

export type ChannelRepairPreview = ReturnType<typeof buildChannelRepairPreview>;
